// src/components/about/ValuesSection.js
import React, { useEffect, useRef } from 'react';
import { fadeIn } from '../../utils/gsapAnimations';

function ValuesSection({ content }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    fadeIn(sectionRef.current, 0.3);
  }, []);

  const values = content?.items || [
    {
      title: 'Sustainability',
      description: 'update with your own details.',
    },
    {
      title: 'Quality',
      description: 'update with your own details.',
    },
    {
      title: 'Empowerment',
      description: 'update with your own details.',
    },
  ];

  return (
    <section ref={sectionRef} className="py-12">
      <h2 className="text-2xl font-playfair-display font-semibold text-primary mb-6 text-center">
        {content?.title || 'Our Values'}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {values.map((value, index) => (
          <div key={index} className="bg-cream rounded-lg shadow-md p-6 text-center">
            <h3 className="text-xl font-playfair-display font-semibold text-secondary mb-2">
              {value?.name}
            </h3>
            <p className="font-montserrat text-secondary">{value?.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ValuesSection;